import { dataAccessEnvironment } from './data-access-environment';

/**
 * Authorization header for APIs that use our common JWT
 */
export class JwtAuthHeaders {
  readonly Authorization: string;

  constructor() {
    this.Authorization = `Bearer ${dataAccessEnvironment.jwt}`;
  }
}
